import React from "react";

const iconArrow = new URL("../assets/images/arrow.svg", import.meta.url);
const iconArrowDark = new URL(
  "../assets/images/arrow-dark.svg",
  import.meta.url
);

export default function MenuListItem({
  icon,
  title,
  bgColor = "bg-dark-blue",
  textColor = "text-white",
  darkArrow = false,
  link,
  onClickCallback,
}) {
  let arrow = iconArrow;
  if (darkArrow) {
    arrow = iconArrowDark;
  }
  return (
    <div className={`rounded-md ${bgColor} ${textColor} px-5 py-4`}>
      <div
        className="flex items-center"
        onClick={() => {
          if (link) {
            window.location.href = link;
          }
          if (typeof onClickCallback === "function") {
            onClickCallback();
          }
        }}
      >
        <div className="flex grow items-center">
          {icon && (
            <div className="flex justify-center w-[32px] shrink-0 mr-4">
              <img src={icon} style={{ height: "30px" }} />
            </div>
          )}
          <div className="uppercase grow tracking-[3px] pr-4 leading-2 text-[13px]">
            {title}
          </div>
        </div>
        <img src={arrow} />
      </div>
    </div>
  );
}
